import React, { PropsWithChildren } from "react";
import { ITranslation, Languages } from "../types";

export interface ILocationContext {
  language: Languages;
  translations: ReadonlyArray<ITranslation>;
  uri: string;
}

const LocalizationContext = React.createContext<ILocationContext>({
  language: Languages.Swedish,
  translations: [],
  uri: '',
});

export const useLocalization = () => React.useContext(LocalizationContext);

export const LocalizationProvider: React.FC<
  PropsWithChildren<ILocationContext>
> = (props) => {
  return (
    <LocalizationContext.Provider
      value={{ language: props.language, translations: props.translations, uri: props.uri }}
    >
      {props.children}
    </LocalizationContext.Provider>
  );
};
